// extracted by mini-css-extract-plugin
module.exports = {"Slider":"Carousel_Slider__3SUnF","title":"Carousel_title__3fci-"};